var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 54,
    viewBox: "0 0 50 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_605_50457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 22.9344C44 31.8731 37.7846 39.3651 29.4258 41.3525C28.0057 41.6901 25.6909 43.2459 24.6545 46C23.6182 43.2459 21.9943 41.6901 20.5742 41.3525C12.2154 39.3651 6 31.8731 6 22.9344C6 12.4772 14.5066 4 25 4C35.4934 4 44 12.4772 44 22.9344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E25B5B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_605_50457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.333 23L24.9997 16.3333L31.6663 23L24.9997 29.6667L18.333 23Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 19.6667V23.6667V19.6667Z",
    fill: "#E25B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 19.6667V23.6667",
    stroke: "#E25B5B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 25V26.3333",
    stroke: "#E25B5B",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_605_50457",
    x: 0,
    y: 0,
    width: 50,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_605_50457"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_605_50457",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_605_50457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(17 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinAlert);
export default __webpack_public_path__ + "static/media/map-pin-alert.324e23ef8fe205b06af9234f0871b75c.svg";
export { ForwardRef as ReactComponent };